import { SmallFleetsProvider } from '../components/SmallFleets/context/SmallFleets.context';
import SmallFleets from '../components/SmallFleets/SmallFleets';

export const SmallFleet = () => (
    <SmallFleetsProvider>
        <SmallFleets />
    </SmallFleetsProvider>
);
